import { BaseBus } from "./BaseBus";
import { InventorySearchBus } from "./InventorySearchBus";
import { v_InventoryBus } from "./v_InventoryBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { QILineItemBus } from "./QILineItem";
/*
 * inventoryNumber - Item
 * quoteInvoiceDesc - Summary
 * fullDescription - Full Description
 *              - Resource
 * 
 */
export class v_QuoteInvoiceBus extends QILineItemBus {
    constructor(busObj: QILineItemBus = null) {
        super(busObj);
        this.isDraged = false;
    }
    CID(): any {
        return this.quoteInvoiceId;
    }
    setId(id: any) {
        this.quoteInvoiceId = id;
    }
    setParentId(id: any) {
        this.quoteId = id;
    }
    changeInventoryItem(data: v_InventoryBus) {
        super.changeInventoryItem(data);
        this.quoteInvoiceDesc = data.inventoryDesc;
    }
    setInventoryLine(data: QILineItemBus) {
        super.setInventoryLine(data);
        this.quoteInvoiceDesc = data.lineDesc;
    }
    setValuesToNull() {
        super.setValuesToNull();
        this.quoteInvoiceId = null;
        this.quoteInvoiceDesc = null;
        this.quoteId = null;
        this.resource = null;
        this.warehouse = null;
    }
    get usesOrderValue(): boolean {
        return true;
    }
    get orderValue(): number {
        return this.sortOrder;
    }
    set orderValue(value: number) {
        this.sortOrder = value;
    }

  quoteInvoiceId: any;
  quoteId: any;
  quoteInvoiceDesc: string;
  resource: string;
  warehouse: string;
    billingTypeName: string;
    isDraged: boolean;
}
